/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export enum Attribute {
  AdultsOnly = "AdultsOnly",
  CharmFlair = "CharmFlair",
  Club = "Club",
  Deluxe = "Deluxe",
  FamilyHoliday = "FamilyHoliday",
  NiceSmallFamilyRun = "NiceSmallFamilyRun",
  ChildFriendly = "ChildFriendly",
  ChildrensBuffet = "ChildrensBuffet",
  BabyCot = "BabyCot",
  BabyEquipment = "BabyEquipment",
  BabySitting = "BabySitting",
  BuggyRent = "BuggyRent",
  GermanSpeakingEntertainmentForKids = "GermanSpeakingEntertainmentForKids",
  ChildrensPool = "ChildrensPool",
  KidsDisco = "KidsDisco",
  ChildrensPlayground = "ChildrensPlayground",
  MaxiClub = "MaxiClub",
  MiniClub = "MiniClub",
  SingleWithChild = "SingleWithChild",
  ChildrensPlayroom = "ChildrensPlayroom",
  SportOffersForChildren = "SportOffersForChildren",
  PetsAllowed = "PetsAllowed",
  PettingZoo = "PettingZoo",
  MedicalService = "MedicalService",
  HandicappedAccessible = "HandicappedAccessible",
  Wellness = "Wellness",
  IndoorPool = "IndoorPool",
  Internet = "Internet",
  FreeParking = "FreeParking",
  FreeWLAN = "FreeWLAN",
  CulinaryDelights = "CulinaryDelights",
  NonSmokingHotel = "NonSmokingHotel",
  NonSmokingRooms = "NonSmokingRooms",
  ParkingSpacesAvailable = "ParkingSpacesAvailable",
  Pool = "Pool",
  HeatedPool = "HeatedPool",
  Restaurant = "Restaurant",
  LaundryService = "LaundryService",
  GreatSportsOffer = "GreatSportsOffer",
  WaterSlide = "WaterSlide",
  Singles = "Singles",
  CityBreaks = "CityBreaks",
  HolidayForTwo = "HolidayForTwo",
  LonghaultJourney = "LonghaultJourney",
  VacationAtMediterraneanSea = "VacationAtMediterraneanSea",
  VacationAtNorthOrBalticSea = "VacationAtNorthOrBalticSea",
  VacationInAustria = "VacationInAustria",
  VacationInGermany = "VacationInGermany",
  VacationInTheMountains = "VacationInTheMountains",
  DirectBeachAccess = "DirectBeachAccess",
  GentlySlopingSandyBeach = "GentlySlopingSandyBeach",
  CentralLocation = "CentralLocation",
  SandyBeach = "SandyBeach",
  HotelNearTheBeach = "HotelNearTheBeach",
  ActionAndFun = "ActionAndFun",
  Cycling = "Cycling",
  Diving = "Diving",
  Windsurfing = "Windsurfing",
  Kitesurfing = "Kitesurfing",
  Fitness = "Fitness",
  Golf = "Golf",
  Hiking = "Hiking",
  HorseRiding = "HorseRiding",
  Sailing = "Sailing",
  Squash = "Squash",
  Tennis = "Tennis",
  Surfing = "Surfing",
  WaterSports = "WaterSports",
  WinterSports = "WinterSports",
  SoccerSchool = "SoccerSchool",
  SwimSchool = "SwimSchool",
  Ayurveda = "Ayurveda",
  BeautyFarm = "BeautyFarm",
  Cosmetic = "Cosmetic",
  Massages = "Massages",
  RelaxationOffersForBodyAndSoul = "RelaxationOffersForBodyAndSoul",
  Sauna = "Sauna",
  Thalasso = "Thalasso",
  QuietLocation = "QuietLocation",
  HoneymoonTravel = "HoneymoonTravel",
  GolfOld = "GolfOld",
  GolfOld2 = "GolfOld2",
  ThemeParks = "ThemeParks",
  LegoLandDenmark = "LegoLandDenmark",
  LegoLandGermany = "LegoLandGermany",
  DisneyLand = "DisneyLand",
  HansaPark = "HansaPark",
  EuropaPark = "EuropaPark",
  PhantasiaLand = "PhantasiaLand",
  HeidePark = "HeidePark",
  MoviePark = "MoviePark",
  Wingfoiling = "Wingfoiling",
  GayHotel = "GayHotel",
  Transfer = "Transfer",
}

export function attributeFromJSON(object: any): Attribute {
  switch (object) {
    case 0:
    case "AdultsOnly":
      return Attribute.AdultsOnly;
    case 1:
    case "CharmFlair":
      return Attribute.CharmFlair;
    case 2:
    case "Club":
      return Attribute.Club;
    case 3:
    case "Deluxe":
      return Attribute.Deluxe;
    case 4:
    case "FamilyHoliday":
      return Attribute.FamilyHoliday;
    case 5:
    case "NiceSmallFamilyRun":
      return Attribute.NiceSmallFamilyRun;
    case 6:
    case "ChildFriendly":
      return Attribute.ChildFriendly;
    case 7:
    case "ChildrensBuffet":
      return Attribute.ChildrensBuffet;
    case 8:
    case "BabyCot":
      return Attribute.BabyCot;
    case 9:
    case "BabyEquipment":
      return Attribute.BabyEquipment;
    case 10:
    case "BabySitting":
      return Attribute.BabySitting;
    case 11:
    case "BuggyRent":
      return Attribute.BuggyRent;
    case 12:
    case "GermanSpeakingEntertainmentForKids":
      return Attribute.GermanSpeakingEntertainmentForKids;
    case 13:
    case "ChildrensPool":
      return Attribute.ChildrensPool;
    case 14:
    case "KidsDisco":
      return Attribute.KidsDisco;
    case 15:
    case "ChildrensPlayground":
      return Attribute.ChildrensPlayground;
    case 16:
    case "MaxiClub":
      return Attribute.MaxiClub;
    case 17:
    case "MiniClub":
      return Attribute.MiniClub;
    case 18:
    case "SingleWithChild":
      return Attribute.SingleWithChild;
    case 19:
    case "ChildrensPlayroom":
      return Attribute.ChildrensPlayroom;
    case 20:
    case "SportOffersForChildren":
      return Attribute.SportOffersForChildren;
    case 21:
    case "PetsAllowed":
      return Attribute.PetsAllowed;
    case 22:
    case "PettingZoo":
      return Attribute.PettingZoo;
    case 23:
    case "MedicalService":
      return Attribute.MedicalService;
    case 24:
    case "HandicappedAccessible":
      return Attribute.HandicappedAccessible;
    case 25:
    case "Wellness":
      return Attribute.Wellness;
    case 26:
    case "IndoorPool":
      return Attribute.IndoorPool;
    case 27:
    case "Internet":
      return Attribute.Internet;
    case 28:
    case "FreeParking":
      return Attribute.FreeParking;
    case 29:
    case "FreeWLAN":
      return Attribute.FreeWLAN;
    case 30:
    case "CulinaryDelights":
      return Attribute.CulinaryDelights;
    case 31:
    case "NonSmokingHotel":
      return Attribute.NonSmokingHotel;
    case 32:
    case "NonSmokingRooms":
      return Attribute.NonSmokingRooms;
    case 33:
    case "ParkingSpacesAvailable":
      return Attribute.ParkingSpacesAvailable;
    case 34:
    case "Pool":
      return Attribute.Pool;
    case 35:
    case "HeatedPool":
      return Attribute.HeatedPool;
    case 36:
    case "Restaurant":
      return Attribute.Restaurant;
    case 37:
    case "LaundryService":
      return Attribute.LaundryService;
    case 38:
    case "GreatSportsOffer":
      return Attribute.GreatSportsOffer;
    case 39:
    case "WaterSlide":
      return Attribute.WaterSlide;
    case 40:
    case "Singles":
      return Attribute.Singles;
    case 41:
    case "CityBreaks":
      return Attribute.CityBreaks;
    case 42:
    case "HolidayForTwo":
      return Attribute.HolidayForTwo;
    case 43:
    case "LonghaultJourney":
      return Attribute.LonghaultJourney;
    case 44:
    case "VacationAtMediterraneanSea":
      return Attribute.VacationAtMediterraneanSea;
    case 45:
    case "VacationAtNorthOrBalticSea":
      return Attribute.VacationAtNorthOrBalticSea;
    case 46:
    case "VacationInAustria":
      return Attribute.VacationInAustria;
    case 47:
    case "VacationInGermany":
      return Attribute.VacationInGermany;
    case 48:
    case "VacationInTheMountains":
      return Attribute.VacationInTheMountains;
    case 49:
    case "DirectBeachAccess":
      return Attribute.DirectBeachAccess;
    case 50:
    case "GentlySlopingSandyBeach":
      return Attribute.GentlySlopingSandyBeach;
    case 51:
    case "CentralLocation":
      return Attribute.CentralLocation;
    case 52:
    case "SandyBeach":
      return Attribute.SandyBeach;
    case 53:
    case "HotelNearTheBeach":
      return Attribute.HotelNearTheBeach;
    case 54:
    case "ActionAndFun":
      return Attribute.ActionAndFun;
    case 55:
    case "Cycling":
      return Attribute.Cycling;
    case 56:
    case "Diving":
      return Attribute.Diving;
    case 57:
    case "Windsurfing":
      return Attribute.Windsurfing;
    case 58:
    case "Kitesurfing":
      return Attribute.Kitesurfing;
    case 59:
    case "Fitness":
      return Attribute.Fitness;
    case 60:
    case "Golf":
      return Attribute.Golf;
    case 61:
    case "Hiking":
      return Attribute.Hiking;
    case 62:
    case "HorseRiding":
      return Attribute.HorseRiding;
    case 63:
    case "Sailing":
      return Attribute.Sailing;
    case 64:
    case "Squash":
      return Attribute.Squash;
    case 65:
    case "Tennis":
      return Attribute.Tennis;
    case 66:
    case "Surfing":
      return Attribute.Surfing;
    case 67:
    case "WaterSports":
      return Attribute.WaterSports;
    case 68:
    case "WinterSports":
      return Attribute.WinterSports;
    case 69:
    case "SoccerSchool":
      return Attribute.SoccerSchool;
    case 70:
    case "SwimSchool":
      return Attribute.SwimSchool;
    case 71:
    case "Ayurveda":
      return Attribute.Ayurveda;
    case 72:
    case "BeautyFarm":
      return Attribute.BeautyFarm;
    case 73:
    case "Cosmetic":
      return Attribute.Cosmetic;
    case 74:
    case "Massages":
      return Attribute.Massages;
    case 75:
    case "RelaxationOffersForBodyAndSoul":
      return Attribute.RelaxationOffersForBodyAndSoul;
    case 76:
    case "Sauna":
      return Attribute.Sauna;
    case 77:
    case "Thalasso":
      return Attribute.Thalasso;
    case 78:
    case "QuietLocation":
      return Attribute.QuietLocation;
    case 79:
    case "HoneymoonTravel":
      return Attribute.HoneymoonTravel;
    case 80:
    case "GolfOld":
      return Attribute.GolfOld;
    case 81:
    case "GolfOld2":
      return Attribute.GolfOld2;
    case 82:
    case "ThemeParks":
      return Attribute.ThemeParks;
    case 83:
    case "LegoLandDenmark":
      return Attribute.LegoLandDenmark;
    case 84:
    case "LegoLandGermany":
      return Attribute.LegoLandGermany;
    case 85:
    case "DisneyLand":
      return Attribute.DisneyLand;
    case 86:
    case "HansaPark":
      return Attribute.HansaPark;
    case 87:
    case "EuropaPark":
      return Attribute.EuropaPark;
    case 88:
    case "PhantasiaLand":
      return Attribute.PhantasiaLand;
    case 89:
    case "HeidePark":
      return Attribute.HeidePark;
    case 90:
    case "MoviePark":
      return Attribute.MoviePark;
    case 91:
    case "Wingfoiling":
      return Attribute.Wingfoiling;
    case 92:
    case "GayHotel":
      return Attribute.GayHotel;
    case 93:
    case "Transfer":
      return Attribute.Transfer;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum Attribute"
      );
  }
}

export function attributeToJSON(object: Attribute): string {
  switch (object) {
    case Attribute.AdultsOnly:
      return "AdultsOnly";
    case Attribute.CharmFlair:
      return "CharmFlair";
    case Attribute.Club:
      return "Club";
    case Attribute.Deluxe:
      return "Deluxe";
    case Attribute.FamilyHoliday:
      return "FamilyHoliday";
    case Attribute.NiceSmallFamilyRun:
      return "NiceSmallFamilyRun";
    case Attribute.ChildFriendly:
      return "ChildFriendly";
    case Attribute.ChildrensBuffet:
      return "ChildrensBuffet";
    case Attribute.BabyCot:
      return "BabyCot";
    case Attribute.BabyEquipment:
      return "BabyEquipment";
    case Attribute.BabySitting:
      return "BabySitting";
    case Attribute.BuggyRent:
      return "BuggyRent";
    case Attribute.GermanSpeakingEntertainmentForKids:
      return "GermanSpeakingEntertainmentForKids";
    case Attribute.ChildrensPool:
      return "ChildrensPool";
    case Attribute.KidsDisco:
      return "KidsDisco";
    case Attribute.ChildrensPlayground:
      return "ChildrensPlayground";
    case Attribute.MaxiClub:
      return "MaxiClub";
    case Attribute.MiniClub:
      return "MiniClub";
    case Attribute.SingleWithChild:
      return "SingleWithChild";
    case Attribute.ChildrensPlayroom:
      return "ChildrensPlayroom";
    case Attribute.SportOffersForChildren:
      return "SportOffersForChildren";
    case Attribute.PetsAllowed:
      return "PetsAllowed";
    case Attribute.PettingZoo:
      return "PettingZoo";
    case Attribute.MedicalService:
      return "MedicalService";
    case Attribute.HandicappedAccessible:
      return "HandicappedAccessible";
    case Attribute.Wellness:
      return "Wellness";
    case Attribute.IndoorPool:
      return "IndoorPool";
    case Attribute.Internet:
      return "Internet";
    case Attribute.FreeParking:
      return "FreeParking";
    case Attribute.FreeWLAN:
      return "FreeWLAN";
    case Attribute.CulinaryDelights:
      return "CulinaryDelights";
    case Attribute.NonSmokingHotel:
      return "NonSmokingHotel";
    case Attribute.NonSmokingRooms:
      return "NonSmokingRooms";
    case Attribute.ParkingSpacesAvailable:
      return "ParkingSpacesAvailable";
    case Attribute.Pool:
      return "Pool";
    case Attribute.HeatedPool:
      return "HeatedPool";
    case Attribute.Restaurant:
      return "Restaurant";
    case Attribute.LaundryService:
      return "LaundryService";
    case Attribute.GreatSportsOffer:
      return "GreatSportsOffer";
    case Attribute.WaterSlide:
      return "WaterSlide";
    case Attribute.Singles:
      return "Singles";
    case Attribute.CityBreaks:
      return "CityBreaks";
    case Attribute.HolidayForTwo:
      return "HolidayForTwo";
    case Attribute.LonghaultJourney:
      return "LonghaultJourney";
    case Attribute.VacationAtMediterraneanSea:
      return "VacationAtMediterraneanSea";
    case Attribute.VacationAtNorthOrBalticSea:
      return "VacationAtNorthOrBalticSea";
    case Attribute.VacationInAustria:
      return "VacationInAustria";
    case Attribute.VacationInGermany:
      return "VacationInGermany";
    case Attribute.VacationInTheMountains:
      return "VacationInTheMountains";
    case Attribute.DirectBeachAccess:
      return "DirectBeachAccess";
    case Attribute.GentlySlopingSandyBeach:
      return "GentlySlopingSandyBeach";
    case Attribute.CentralLocation:
      return "CentralLocation";
    case Attribute.SandyBeach:
      return "SandyBeach";
    case Attribute.HotelNearTheBeach:
      return "HotelNearTheBeach";
    case Attribute.ActionAndFun:
      return "ActionAndFun";
    case Attribute.Cycling:
      return "Cycling";
    case Attribute.Diving:
      return "Diving";
    case Attribute.Windsurfing:
      return "Windsurfing";
    case Attribute.Kitesurfing:
      return "Kitesurfing";
    case Attribute.Fitness:
      return "Fitness";
    case Attribute.Golf:
      return "Golf";
    case Attribute.Hiking:
      return "Hiking";
    case Attribute.HorseRiding:
      return "HorseRiding";
    case Attribute.Sailing:
      return "Sailing";
    case Attribute.Squash:
      return "Squash";
    case Attribute.Tennis:
      return "Tennis";
    case Attribute.Surfing:
      return "Surfing";
    case Attribute.WaterSports:
      return "WaterSports";
    case Attribute.WinterSports:
      return "WinterSports";
    case Attribute.SoccerSchool:
      return "SoccerSchool";
    case Attribute.SwimSchool:
      return "SwimSchool";
    case Attribute.Ayurveda:
      return "Ayurveda";
    case Attribute.BeautyFarm:
      return "BeautyFarm";
    case Attribute.Cosmetic:
      return "Cosmetic";
    case Attribute.Massages:
      return "Massages";
    case Attribute.RelaxationOffersForBodyAndSoul:
      return "RelaxationOffersForBodyAndSoul";
    case Attribute.Sauna:
      return "Sauna";
    case Attribute.Thalasso:
      return "Thalasso";
    case Attribute.QuietLocation:
      return "QuietLocation";
    case Attribute.HoneymoonTravel:
      return "HoneymoonTravel";
    case Attribute.GolfOld:
      return "GolfOld";
    case Attribute.GolfOld2:
      return "GolfOld2";
    case Attribute.ThemeParks:
      return "ThemeParks";
    case Attribute.LegoLandDenmark:
      return "LegoLandDenmark";
    case Attribute.LegoLandGermany:
      return "LegoLandGermany";
    case Attribute.DisneyLand:
      return "DisneyLand";
    case Attribute.HansaPark:
      return "HansaPark";
    case Attribute.EuropaPark:
      return "EuropaPark";
    case Attribute.PhantasiaLand:
      return "PhantasiaLand";
    case Attribute.HeidePark:
      return "HeidePark";
    case Attribute.MoviePark:
      return "MoviePark";
    case Attribute.Wingfoiling:
      return "Wingfoiling";
    case Attribute.GayHotel:
      return "GayHotel";
    case Attribute.Transfer:
      return "Transfer";
    default:
      return "UNKNOWN";
  }
}

export function attributeToNumber(object: Attribute): number {
  switch (object) {
    case Attribute.AdultsOnly:
      return 0;
    case Attribute.CharmFlair:
      return 1;
    case Attribute.Club:
      return 2;
    case Attribute.Deluxe:
      return 3;
    case Attribute.FamilyHoliday:
      return 4;
    case Attribute.NiceSmallFamilyRun:
      return 5;
    case Attribute.ChildFriendly:
      return 6;
    case Attribute.ChildrensBuffet:
      return 7;
    case Attribute.BabyCot:
      return 8;
    case Attribute.BabyEquipment:
      return 9;
    case Attribute.BabySitting:
      return 10;
    case Attribute.BuggyRent:
      return 11;
    case Attribute.GermanSpeakingEntertainmentForKids:
      return 12;
    case Attribute.ChildrensPool:
      return 13;
    case Attribute.KidsDisco:
      return 14;
    case Attribute.ChildrensPlayground:
      return 15;
    case Attribute.MaxiClub:
      return 16;
    case Attribute.MiniClub:
      return 17;
    case Attribute.SingleWithChild:
      return 18;
    case Attribute.ChildrensPlayroom:
      return 19;
    case Attribute.SportOffersForChildren:
      return 20;
    case Attribute.PetsAllowed:
      return 21;
    case Attribute.PettingZoo:
      return 22;
    case Attribute.MedicalService:
      return 23;
    case Attribute.HandicappedAccessible:
      return 24;
    case Attribute.Wellness:
      return 25;
    case Attribute.IndoorPool:
      return 26;
    case Attribute.Internet:
      return 27;
    case Attribute.FreeParking:
      return 28;
    case Attribute.FreeWLAN:
      return 29;
    case Attribute.CulinaryDelights:
      return 30;
    case Attribute.NonSmokingHotel:
      return 31;
    case Attribute.NonSmokingRooms:
      return 32;
    case Attribute.ParkingSpacesAvailable:
      return 33;
    case Attribute.Pool:
      return 34;
    case Attribute.HeatedPool:
      return 35;
    case Attribute.Restaurant:
      return 36;
    case Attribute.LaundryService:
      return 37;
    case Attribute.GreatSportsOffer:
      return 38;
    case Attribute.WaterSlide:
      return 39;
    case Attribute.Singles:
      return 40;
    case Attribute.CityBreaks:
      return 41;
    case Attribute.HolidayForTwo:
      return 42;
    case Attribute.LonghaultJourney:
      return 43;
    case Attribute.VacationAtMediterraneanSea:
      return 44;
    case Attribute.VacationAtNorthOrBalticSea:
      return 45;
    case Attribute.VacationInAustria:
      return 46;
    case Attribute.VacationInGermany:
      return 47;
    case Attribute.VacationInTheMountains:
      return 48;
    case Attribute.DirectBeachAccess:
      return 49;
    case Attribute.GentlySlopingSandyBeach:
      return 50;
    case Attribute.CentralLocation:
      return 51;
    case Attribute.SandyBeach:
      return 52;
    case Attribute.HotelNearTheBeach:
      return 53;
    case Attribute.ActionAndFun:
      return 54;
    case Attribute.Cycling:
      return 55;
    case Attribute.Diving:
      return 56;
    case Attribute.Windsurfing:
      return 57;
    case Attribute.Kitesurfing:
      return 58;
    case Attribute.Fitness:
      return 59;
    case Attribute.Golf:
      return 60;
    case Attribute.Hiking:
      return 61;
    case Attribute.HorseRiding:
      return 62;
    case Attribute.Sailing:
      return 63;
    case Attribute.Squash:
      return 64;
    case Attribute.Tennis:
      return 65;
    case Attribute.Surfing:
      return 66;
    case Attribute.WaterSports:
      return 67;
    case Attribute.WinterSports:
      return 68;
    case Attribute.SoccerSchool:
      return 69;
    case Attribute.SwimSchool:
      return 70;
    case Attribute.Ayurveda:
      return 71;
    case Attribute.BeautyFarm:
      return 72;
    case Attribute.Cosmetic:
      return 73;
    case Attribute.Massages:
      return 74;
    case Attribute.RelaxationOffersForBodyAndSoul:
      return 75;
    case Attribute.Sauna:
      return 76;
    case Attribute.Thalasso:
      return 77;
    case Attribute.QuietLocation:
      return 78;
    case Attribute.HoneymoonTravel:
      return 79;
    case Attribute.GolfOld:
      return 80;
    case Attribute.GolfOld2:
      return 81;
    case Attribute.ThemeParks:
      return 82;
    case Attribute.LegoLandDenmark:
      return 83;
    case Attribute.LegoLandGermany:
      return 84;
    case Attribute.DisneyLand:
      return 85;
    case Attribute.HansaPark:
      return 86;
    case Attribute.EuropaPark:
      return 87;
    case Attribute.PhantasiaLand:
      return 88;
    case Attribute.HeidePark:
      return 89;
    case Attribute.MoviePark:
      return 90;
    case Attribute.Wingfoiling:
      return 91;
    case Attribute.GayHotel:
      return 92;
    case Attribute.Transfer:
      return 93;
    default:
      return 0;
  }
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
